import { pluralDays } from '../../../../../../../utils/string';

export const getDurationText = (duration: number) => {
  return duration === 1 ? 'Посуточно' : pluralDays(duration);
};
